import { Box, Text, useMantineTheme } from '@mantine/core';
import { NodeId } from '../../types';
import { NodeOutput } from '../node-output/node-output';

export type TemplateOutputProps = {
  nodeId: NodeId;
  emptyLabel?: string;
  withPanel?: boolean;
};

export const TemplateOutput = ({
  nodeId,
  emptyLabel = 'Empty',
  withPanel = true,
}: TemplateOutputProps) => {
  return (
    <NodeOutput
      nodeId={nodeId}
      mode="template"
      emptyLabel={emptyLabel}
      withPanel={withPanel}
    />
  );
};
